/**
 * @generated SignedSource<<b5e25d6bd8bc343802cd7d363549e292>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespUnavailableHeader_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedContactSellerButton_user" | "SharedGateViewPrice_user">;
  readonly " $fragmentType": "PdpRespUnavailableHeader_user";
};
export type PdpRespUnavailableHeader_user$key = {
  readonly " $data"?: PdpRespUnavailableHeader_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespUnavailableHeader_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespUnavailableHeader_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedContactSellerButton_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedGateViewPrice_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "b45d6ef533cd0121f7cebe2f2d083f68";

export default node;
